import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { Text } from '@retailer-platform/shared-components'
import { MerchandisingFormSection } from 'domains/merchandising/components/form-section/MerchandisingFormSection'
import { useDashMessages } from 'intl/intl.hooks'

const sectionContainer = css({
  display: 'flex',
  '& > div': {
    flex: '1 0 25%',
  },
})

interface Props {
  id
  bannerId
}

export const BannerUpdateDetail: FunctionComponent<Props> = ({ id, bannerId }) => {
  const messages = useDashMessages({
    emptyValue: 'bannersDomain.field.empty.value',
    placementIdLabel: 'bannersDomain.details.details.placementId',
    bannerIdLabel: 'bannersDomain.details.details.bannerId',
  })

  return (
    <MerchandisingFormSection titleId="bannersDomain.edit.details.title">
      <div css={sectionContainer}>
        <div>
          <Text weight="semibold">{messages.placementIdLabel}</Text>
          <Text size="medium">{id || messages.emptyValue}</Text>
        </div>
        <div>
          <Text weight="semibold">{messages.bannerIdLabel}</Text>
          <Text size="medium">{bannerId || messages.emptyValue}</Text>
        </div>
      </div>
    </MerchandisingFormSection>
  )
}
